import { isFailClosed } from '@/lib/agent-platform';

import { FailClosedNotice } from './fail-closed-notice';

interface SummaryOfFindingsSectionProps {
  /** Narrative summary string (may collapse to FAIL_CLOSED_PLACEHOLDER on audit failure). */
  summary: string | null | undefined;
}

/**
 * Section block for the rationale's `summary_of_findings` narrative. Routes
 * the fail-closed placeholder to the warning UI so the literal placeholder
 * text never appears as ordinary body copy.
 */
export function SummaryOfFindingsSection({ summary }: SummaryOfFindingsSectionProps) {
  if (!summary) return null;

  return (
    <section className="mb-8 rounded-lg border bg-white p-6 shadow-sm">
      <h2 className="mb-4 text-lg font-semibold text-[#051923]">Summary of Findings</h2>
      {isFailClosed(summary) ? (
        <FailClosedNotice fieldLabel="Summary of findings" />
      ) : (
        <div className="prose prose-sm max-w-none text-gray-700">
          <p>{summary}</p>
        </div>
      )}
    </section>
  );
}
